import { TESTIMONIAL_PAGE } from './actionTypes';

const getTestimonialData = (vertical_id, type) => (
  dispatch,
  getState,
  { api }
) => {
  dispatch({
    type: TESTIMONIAL_PAGE.TESTIMONIAL_PAGE_REQUEST,
    payload: {},
    test: api
      .post(`testimonial.json`)
      .then(res => {
        const testimonial_data = {
          vertical_id: vertical_id,
          data: res.data.data,
          type: type,
        };
        dispatch({
          type: TESTIMONIAL_PAGE.TESTIMONIAL_PAGE_SUCCESS,
          payload: testimonial_data,
        });

        return res.data;
      })
      .catch(error => {
        dispatch({
          type: TESTIMONIAL_PAGE.TESTIMONIAL_PAGE_FAILURE,
          error,
        });
      }),
  });
};

export const TestimonialActions = {
  getTestimonialData,
};
